import { createSelector } from 'reselect';
import { isSpecificCollegeOrDefaultSelector } from '../ChildrenInfoWorkflowSelector';
import { COLLEGE_NAME, DURATION, SCHOOL_TYPE } from '../../Summaries/SummaryConstants';
import dictionarySelector from '../../Summaries/SummaryDictionarySelector';

const nextIteratorsSelector = createSelector(
  isSpecificCollegeOrDefaultSelector,
  dictionarySelector,
  (IsSpecificCollege, dictionary) => {
    if (IsSpecificCollege === true) {
      return [COLLEGE_NAME, DURATION].map(dependencies => dictionary[dependencies].iterator);
    }
    return [SCHOOL_TYPE].map(dependencies => dictionary[dependencies].iterator);
  },
);

export default nextIteratorsSelector;
